var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-row form-item"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "raft-user-groups-wrapper"
    }
  }, [_vm.label ? _c('label', {
    attrs: {
      "id": _vm.fieldData.field_name + '-label'
    }
  }, [_vm._v(_vm._s(_vm.label) + ":")]) : _vm._e(), _vm._v(" "), _c('b-form-select', {
    key: _vm.selected,
    class: _vm.fieldClass,
    attrs: {
      "disabled": !_vm.userUuid || _vm.disabled || _vm.groupOptions.length < 1,
      "id": _vm.fieldData.field_name,
      "required": _vm.isRequired,
      "name": _vm.fieldData.field_name,
      "options": _vm.groupOptions
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue($event);
      }
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v("\n          -- Select a group --\n        ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }